/**
 *  Init Select2 plugin
 */
const initSelect2 = () => {
    $("select").select2({
        minimumResultsForSearch: -1
    });

    $("select.select--secondary").select2({
        minimumResultsForSearch: -1,
        theme: "secondary"
    });
};

export const initSelect = initSelect2;
